import React, { useMemo } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import Header from "../../../components/Header";
import NotTakingExam from "./notTakingExam";
import styles from "./index.module.scss";
import CamCaptureRecord from "./camCaptureRecord";
import ScreenCaptureRecord from "./screenCaptureRecord";
import ShiftBrowser from "./shiftBrowser";
import MultipleScreen from "./multipleScreen";
import Submitted from "./submitted";
import All from "./all";
import Download from "./download";
import InvigilationList from "./invigilationList";
import { useLocation } from "react-use";
import classNames from "classnames";
import { ChangeIp } from "./changeIp";
import { AbnormalLogin } from "./abnormalLogin";

interface PageParams {
    type?: string;
}

export default function InvigilationLog({
    match
}: RouteComponentProps<PageParams>) {
    const location = useLocation();
    const isFull = useMemo(() => {
        if (!location.pathname) {
            return false;
        }
        const next = ["/exam/invigilation/list"];
        return next.includes(location.pathname);
    }, [location.pathname]);
    return (
        <div className={styles.root}>
            <Header />

            <div className={classNames(styles.body, isFull && styles.full)}>
                <Switch>
                    <Route
                        exact
                        path="/exam/invigilation/log/not_taking_exam"
                        component={NotTakingExam}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/cam_capture_record"
                        component={CamCaptureRecord}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/screen_capture_record"
                        component={ScreenCaptureRecord}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/shift_browser"
                        component={ShiftBrowser}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/multiple_screen"
                        component={MultipleScreen}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/submitted"
                        component={Submitted}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/all"
                        component={All}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/log/download"
                        component={Download}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/list"
                        component={InvigilationList}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/ip"
                        component={ChangeIp}
                    />

                    <Route
                        exact
                        path="/exam/invigilation/login"
                        component={AbnormalLogin}
                    />
                </Switch>
            </div>
        </div>
    );
}
